import { initPossibilitiesBlocks } from './blocks/possibilities';
import { initProjectsSliderBlocks } from './blocks/projects-slider';
import { initPhotoSliderBlocks } from './blocks/photo-slider';
import { initProcessSliderBlocks } from './blocks/process-slider';
import { initMarqueeRevealBlocks } from './blocks/marquee-reveal';
import { initServiceAreaMapBlocks } from './blocks/service-area-map';
import { initGalleryBlocks } from './blocks/gallery';
import { initPromiseStatsBlocks } from './blocks/promise-stats';
import { initFaqBlocks } from './blocks/faq';
import { initVideoModalBlocks } from './blocks/video-modal';
import { initCostEstimatorBlocks } from './blocks/cost-estimator';
import { initFloatingHeader } from './blocks/floating-header';
import { initImageFeatureParallax } from './blocks/image-feature-parallax';

document.addEventListener('DOMContentLoaded', () => {
	initPossibilitiesBlocks();
	initProjectsSliderBlocks();
	initPhotoSliderBlocks();
	initProcessSliderBlocks();
	initMarqueeRevealBlocks();
	initServiceAreaMapBlocks();
	initGalleryBlocks();
	initPromiseStatsBlocks();
	initFaqBlocks();
	initVideoModalBlocks();
	initCostEstimatorBlocks();
	initFloatingHeader();
	initImageFeatureParallax();
});
